import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export const PromoVideo = () => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = muted;
    videoRef.current.muted = !muted;
    if (muted) videoRef.current.currentTime = 0;
    setMuted(!muted);
  };

  return (
    <div className="relative mx-auto w-[240px] sm:w-[270px]" data-testid="promo-video-wrapper">
      <div className="rounded-[2rem] overflow-hidden border-[6px] border-[#003E75] shadow-2xl shadow-[#003E75]/30 bg-[#003E75]">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className="block w-full h-auto"
          data-testid="promo-video"
        >
          <source src="/assets/promo-video.webm" type="video/webm" />
          <source src="/assets/promo-video.mp4" type="video/mp4" />
        </video>
      </div>
      <button
        type="button"
        onClick={toggleSound}
        aria-label={muted ? "Ieslēgt skaņu" : "Izslēgt skaņu"}
        data-testid="promo-video-sound-button"
        className="absolute bottom-4 right-4 h-10 w-10 rounded-full bg-[#ED1C27] text-white flex items-center justify-center shadow-lg transition-transform hover:scale-110"
      >
        {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
      </button>
    </div>
  );
};
